import { Eye } from 'lucide-react'
import { cn } from '@/lib/utils'
import { BID_READ_ONLY_MESSAGE, VIEW_ONLY_MESSAGE, useIsViewOnly } from '@/hooks/useViewOnly'

interface ViewOnlyNoticeProps {
  /** Replaces the default line; keep the "view-only access" wording. */
  message?: string
  className?: string
}

/**
 * The calm, neutral notice a read-only user sees where a write or AI surface
 * would otherwise be — muted text, never the destructive error treatment,
 * because nothing has gone wrong.
 *
 * It only renders where the page has decided the user cannot edit, so the
 * default line follows the reason: a viewer has view-only access everywhere; a
 * member who is not on the bid is told how to get edit access.
 */
export function ViewOnlyNotice({ message, className }: ViewOnlyNoticeProps) {
  const isViewOnly = useIsViewOnly()
  const line = message ?? (isViewOnly ? `${VIEW_ONLY_MESSAGE}.` : BID_READ_ONLY_MESSAGE)
  return (
    <p role="status" className={cn('flex items-center gap-2 text-meta', className)}>
      <Eye className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
      <span>{line}</span>
    </p>
  )
}
